// extracted by css-extract-rspack-plugin
export default {"Box":"table-group-module__Box__Wk69Z","isOver":"table-group-module__isOver__RLAYE"};